import { render, staticRenderFns } from "./MalfunctionExtraSelections.vue?vue&type=template&id=524b5ed0&scoped=true"
import script from "./MalfunctionExtraSelections.vue?vue&type=script&lang=js"
export * from "./MalfunctionExtraSelections.vue?vue&type=script&lang=js"
import style0 from "./MalfunctionExtraSelections.vue?vue&type=style&index=0&id=524b5ed0&prod&scoped=true&lang=css"
import style1 from "./MalfunctionExtraSelections.vue?vue&type=style&index=1&id=524b5ed0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b5ed0",
  null
  
)

export default component.exports